module.exports = __webpack_public_path__ + "6806ccde39008fc09aee75c78f040990.svg";